export class Bac {
    constructor(
        public value?: string,
        public label?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/bac.model.ts